<template>
  <div>
    <b-container>
      <div class="mt-4 d-flex justify-content-between">
        <back-arrow v-if="videoId" :confirm="true"
                    :title="$t('Modify') + ' ' + $t('a.e') + ' ' + $t('video')" route-back="VideoIndex"/>
        <back-arrow v-else :confirm="askConfirm" :title="$t('Add') + ' ' + $t('a.e')  + ' ' +  $t('video')"
                    route-back="VideoIndex"/>
      </div>

      <div class="row">
        <div class="col-md-12">
          <b-card class="mt-2 mb-4 shadow-sm card-scrollable">
            <b-form @submit.stop.prevent="onSubmit">

              <div class="row">
                <div class="col-md-6">
                  <b-form-group
                    :invalid-feedback="form.title.invalidFeedback"
                    :label="$t('Video.title')"
                    :state="form.title.state"
                    class="medium-label mb-4 required-input"
                    label-for="title-input">
                    <b-form-input
                      id="title-input"
                      v-model="form.title.value"
                      :state="form.title.state"
                      maxlength="250"
                      required
                      tabindex="1"
                      type="text"
                      v-on:change="askConfirm=true;removeInvalidFeedback('title')">
                    </b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-6">

                  <b-form-group
                    :invalid-feedback="form.fileRobustagno.invalidFeedback"
                    class="medium-label mb-4">
                    <div class="d-flex">
                      <label for="fileRobustagno-input">
                        {{ $t('FILE') }}
                      </label>
                    </div>
                    <b-form-file
                      id="fileRobustagno-input"
                      v-model="form.fileRobustagno.value"
                      :drop-placeholder="$t('drop-placeholder')"
                      :placeholder="form.fileRobustagno.value"
                      :state="form.fileRobustagno.state"
                      tabindex="2"
                      accept=".wav, .wave, .mp4, .m4a, .m4p, .m4b, .m4r, .m4v, .webm, .mov, .avi, .wmv, .avchd, .flv"
                      :required="!isEdit">
                    </b-form-file>
                  </b-form-group>
                </div>
                <div class="col-md-12">
                  <span class="text-grey d-flex flex-row-reverse italic-text">{{ $t('Optional') }}</span>
                  <b-card class="mt-2 mb-4 shadow-sm bg-grey-custom">
                    <div class="row">
                      <AutocompleteField
                        ref="autocomplete"
                        v-model="this.form.practiceAssociation.practice"
                        :input-class="'medium-label mb-4'"
                        :input-id="'practice-input'"
                        :tab-index="7"
                        :input-label="$t('Practice3')"
                        :items="this.practices"
                        :required=false
                        @elementValueChanged="getSelectedValue">
                      </AutocompleteField>
                      <div class="col-md-6">
                        <b-form-group
                          :invalid-feedback="form.practiceAssociation.specialLink.invalidFeedback"
                          :state="form.practiceAssociation.specialLink.state"
                          class="medium-label mb-4 mt-md-4">
                          <b-form-checkbox
                            v-show="this.form.practiceAssociation.practice&&this.form.practiceAssociation.practice.id"
                            id="specialLink-input"
                            v-model="form.practiceAssociation.specialLink.value"
                            :state="form.practiceAssociation.specialLink.state"
                            required
                            v-on:change="askConfirm=true;">
                            {{ $t('Resource.special.link') }}
                          </b-form-checkbox>
                        </b-form-group>
                      </div>
                      <div class=col-md-6>
                        <b-form-group v-if="this.form.practiceAssociation.specialLink.value"
                                      :invalid-feedback="form.practice.invalidFeedback"
                                      :label="$t('ObjectToLink')"
                                      :state="form.practice.state"
                                      class="medium-label mb-4"
                                      label-for="practice-input">
                          <b-form-select
                            id="practice-input"
                            v-model="form.practiceAssociation.object.value"
                            :state="form.practiceAssociation.object.state"
                            v-on:change="askConfirm=true;">
                            <template v-if="practices.length === 0" #first>
                              <b-form-select-option :value="null" disabled>-- Aucune practice --</b-form-select-option>
                            </template>
                            <!-- Ajout des données de "timeMarkerList" -->
                            <optgroup
                              :label="form.practiceAssociation.object.options.timeMarkerList.length > 1 ? $t('TimeMarkers') : $t('TimeMarker')"
                              v-if="form.practiceAssociation.object.options && form.practiceAssociation.object.options.timeMarkerList.length > 0">
                              <option v-for="timeMarker in form.practiceAssociation.object.options.timeMarkerList"
                                      :value="{...timeMarker,objectType:'timeMarker'}">
                                {{ timeMarker.index }} - {{ timeMarker.title }}
                              </option>
                            </optgroup>

                            <!-- Ajout des données de "timeMarkerTaskList" -->
                            <optgroup v-for="timeMarker in form.practiceAssociation.object.options.timeMarkerList"
                                      :label="getLabelForTimeMarkerTaskListFromTimeMarker(timeMarker)"
                                      v-if="findAllTimeMarkerTasksFromTimeMarker(timeMarker).length > 0">
                              <option v-for="timeMarkerTask in findAllTimeMarkerTasksFromTimeMarker(timeMarker)"
                                      :value="{...timeMarkerTask,objectType:'timeMarkerTask'}">
                                {{ timeMarker.index }}.{{ timeMarkerTask.index }} - {{ timeMarkerTask.title }}
                              </option>
                            </optgroup>

                            <!-- Ajout des données de "astuceList" -->
                            <optgroup
                              v-for="timeMarkerTask in form.practiceAssociation.object.options.timeMarkerTaskList"
                              :label="getLabelForAstuceListFromTimeMarkerTask(timeMarkerTask)"
                              v-if="findAllAstucesFromTimeMarkerTask(timeMarkerTask).length > 0">
                              <option v-for="astuce in findAllAstucesFromTimeMarkerTask(timeMarkerTask)"
                                      :value="{...astuce,objectType:'astuce'}">
                                {{ astuce.title }}
                              </option>
                            </optgroup>
                          </b-form-select>
                        </b-form-group>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12 d-flex flex-row-reverse">
                        <b-button tabindex="10" variant="primary"
                                  :disabled="!this.form.practiceAssociation.practice || !this.form.practiceAssociation.practice.id"
                                  @click="createResourceAssociation()">{{ "Créer le lien" }}
                        </b-button>
                      </div>
                    </div>
                    <div class="row" v-if="this.objectsToLink.length>0">
                      <div class="col-md-12 mt-4">
                        <div class="d-flex flex-column mb-4 custom-border">
                        </div>
                      </div>
                      <div class="col-md-12 d-flex" v-for="association in this.objectsToLink">
                        <p>{{ nameAssociation(association) }}</p>
                        <p class="ml-4 textual-link-to-delete" @click="deleteAssociation(association)">
                          {{ $t('Delete') }}</p>
                      </div>
                    </div>
                  </b-card>

                </div>

              </div>
              <div class="d-flex justify-content-end">
                <b-button tabindex="10" type="submit" class="ph-btn" variant="primary" :disabled="uploadingVideo">
                  {{ videoId ? $t('Validate') : $t('Add') + ' ' + $t('l.e') + ' ' + $t('video') }} <i
                  class="ph-custom ph-spinner-gap-fill ml-1 spinner" v-show="uploadingVideo"/>
                </b-button>
              </div>
            </b-form>
          </b-card>
        </div>
      </div>
    </b-container>

  </div>
</template>

<script>

import api from '../../services/api'
import BackArrow from '../../components/b122/BackArrow'
import DateField from '../../components/b122/editFields/DateField'
import AutocompleteField from '../../components/b122/editFields/AutocompleteField'

export default {

  name: 'VideoCreateEdit',

  components: {
    BackArrow,
    DateField,
    AutocompleteField
  },

  data() {
    return {
      videoId: this.$route.params.videoId,
      isEdit: false,
      uploadingVideo: false,
      askConfirm: false,
      form: {
        title:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        fileRobustagno:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        practiceAssociation:
          {
            practice: {},
            specialLink: {
              state: null,
              invalidFeedback: null,
              value: null
            },
            object: {
              state: null,
              invalidFeedback: null,
              value: null,
              options: {}
            }
          },
        practice: {}
      },
      practices: [],
      technicians: [],
      video: {},
      objectsToLink: []
    }
  },

  mounted() {
    this.fetchData()
  },

  watch: {
    'form.practiceAssociation.practice': async function () {
      if (this.form.practiceAssociation.practice && this.form.practiceAssociation.practice.hasOwnProperty('id')) {
        await this.fetchAllObjetsThatCanBeAssociated()
      }
    },
    'form.practiceAssociation.specialLink.value': async function () {
      this.form.practiceAssociation.object.value = null
      if (this.form.practiceAssociation.practice && this.form.practiceAssociation.practice.hasOwnProperty('id')) {
        await this.fetchAllObjetsThatCanBeAssociated()
      }
    }
  },

  methods: {

    async deleteAssociation(association) {
      let index
      if (association.id) {
        index = this.objectsToLink.findIndex(obj => obj.id === association.id)
        if (index === -1) return
      } else {
        index = this.objectsToLink.findIndex(obj =>
          (association.id ? obj.id === association.id : true) &&
          obj.practiceId === association.practiceId &&
          obj.practiceName === association.practiceName &&
          (
            (obj.practiceAssociation && association.practiceAssociation)
              ? obj.practiceAssociation.object === association.practiceAssociation.object
              : (!obj.practiceAssociation && !association.practiceAssociation)
          )
        )
        if (index === -1) return
      }
      this.objectsToLink.splice(index, 1)
    },

    nameAssociation(association) {
      let str = ''
      if (association.practiceNumber) {
        str += association.practiceNumber + ' - '
      }
      if (association.practiceName) {
        str += association.practiceName
      }
      if (association.practiceAssociation && association.practiceAssociation.title && association.practiceName !== association.practiceAssociation.title) {
        str += (' - ' + association.practiceAssociation.title)
      }
      return str
    },

    getSelectedValue(data) {
      this.form.practiceAssociation.practice = data
    },

    async fetchData() {
      await this.fetchAllPractice()
      if (this.videoId) {
        await this.fetchVideo()
      }
    },

    async fetchVideo() {
      api
        .get('/resource/' + this.videoId)
        .then(response => {
          this.resource = response.data
          this.setInitialValues()
        })
    },

    setInitialValues() {
      if (this.resource != null) {
        this.isEdit = true
        this.form.title.value = this.resource.title
        if (this.resource.fileRobustagno && this.resource.fileRobustagno.fileName) {
          this.form.fileRobustagno.value = this.resource.fileRobustagno.fileName
        }
        if (this.resource.resourceAssociations.length > 0) {
          this.setInitialResourceAssociation(this.resource.resourceAssociations)
        }
      }
    },

    async fetchAllPractice() {
      await api
        .get('/practice/')
        .then(response => {
          this.practices = response.data
        })
    },

    async fetchAllObjetsThatCanBeAssociated() {
      if (this.form.practiceAssociation.practice.id) {
        await api
          .get('/practice/getObjectsThatCanBeAssociatedWithResource/' + this.form.practiceAssociation.practice.id)
          .then(response => {
            this.form.practiceAssociation.object.options = response.data
          })
      }
    },

    async onSubmit(e) {
      if (this.form.fileRobustagno.value.size > 524288000) {
        e.preventDefault()
        this.form.fileRobustagno.state = false
        this.form.fileRobustagno.invalidFeedback = this.$i18n.t('file.too.big.error')
        return
      }
      this.uploadingVideo = true
      let data = new FormData()
      data.append('title', this.form.title.value)
      data.append('fileRobustagno', this.form.fileRobustagno.value)
      data.append('resourceType', 'FILE')
      data.append('isVideoRobustagno', 'true')
      data.append('source', 'Robustagno')
      if (this.objectsToLink.length > 0) {
        data.append('objectsToLink', JSON.stringify(this.objectsToLink))
      }

      let url = 'resource'
      if (this.videoId) {
        url = '/resource/' + this.videoId
      }

      await api({
        method: 'POST',
        url: url,
        data: data
      })
        .then(() => {
          this.uploadingVideo = false
          this.$router.push({
              name: 'VideoIndex'
            },
            () => {
              this.$nextTick(() => {
                this.successToast(this.form.title.value)
              })
            })
        })
        .catch((error) => {
          this.uploadingVideo = false
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'VideoIndex'
            })
          } else if (error.response.status === 403) {
            const invalidField = error.response.data.invalidField
            this.form[invalidField]['state'] = false
            this.form[invalidField]['invalidFeedback'] = this.$i18n.t(error.response.data.message)
          }
        })
    },
    createResourceAssociation() {
      const {practice, object} = this.form.practiceAssociation

      const newObject = {
        ...(
          practice && practice.id
            ? {
              practiceId: practice.id,
              practiceNumber: practice.number,
              practiceName: practice.title
            }
            : {}
        ),
        ...(
          object.value
            ? {
              practiceAssociation: {
                object: `${object.value.objectType}-${object.value.id}`,
                title: object.value.title
              }
            }
            : {}
        )
      }

      this.objectsToLink.push(newObject)
      this.resetPracticeAssociationForm()
      this.$refs.autocomplete.reset()
    },

    resetPracticeAssociationForm() {
      this.form.practiceAssociation = {
        practice: {},
        specialLink: {
          state: null,
          invalidFeedback: null,
          value: null
        },
        object: {
          state: null,
          invalidFeedback: null,
          value: null,
          options: {}
        }
      }
    },

    setInitialResourceAssociation(resourceAssociations) {
      this.objectsToLink = resourceAssociations.map(resource => {
        let practiceAssociation
        if (resource.objectId && resource.objectType) {
          practiceAssociation = {
            object: `${resource.objectType}-${resource.objectId}`,
            title: resource.objectName
          }
        }

        return {
          ...(resource.practice && resource.practice.id ? {
            id: resource.id,
            practiceId: resource.practice.id,
            practiceNumber: resource.practice.number,
            practiceName: resource.practice.title
          } : {}),
          ...(practiceAssociation ? {practiceAssociation} : {})
        }
      })
    },

    getLabelForTimeMarkerTaskListFromTimeMarker(timeMarker) {
      var timeMarkerTasksNb = this.findAllTimeMarkerTasksFromTimeMarker(timeMarker).length
      if (timeMarkerTasksNb > 1) {
        return this.$t('TimeMarkerTasks', {index: timeMarker.index})
      } else {
        return this.$t('TimeMarkerTask', {index: timeMarker.index})
      }
    },

    getLabelForAstuceListFromTimeMarkerTask(timeMarkerTask) {
      var astucesNb = this.findAllAstucesFromTimeMarkerTask(timeMarkerTask).length
      if (astucesNb > 1) {
        return this.$t('Astuces', {index: this.getTimeMarkerFromTimeMarkerTask(timeMarkerTask).index + '.' + timeMarkerTask.index})
      } else {
        return this.$t('Astuce', {index: this.getTimeMarkerFromTimeMarkerTask(timeMarkerTask).index + '.' + timeMarkerTask.index})
      }
    },

    findAllTimeMarkerTasksFromTimeMarker(timeMarker) {
      return this.form.practiceAssociation.object.options.timeMarkerTaskList.filter((timeMarkerTask) => timeMarkerTask.timeMarkerId === timeMarker.id)
    },

    findAllAstucesFromTimeMarkerTask(timeMarkerTask) {
      return this.form.practiceAssociation.object.options.astuceList.filter((astuce) => astuce.timeMarkerTaskId === timeMarkerTask.id)
    },

    getTimeMarkerFromTimeMarkerTask(timeMarkerTask) {
      return this.form.practiceAssociation.object.options.timeMarkerList.find((timeMarker) => timeMarker.id === timeMarkerTask.timeMarkerId)
    },

    removeInvalidFeedback(field) {
      this.form[field]['state'] = null
    },

    successToast(taskName) {
      this.$bvToast.toast(this.$i18n.t('Video') + ' "' + taskName + '" ' + this.$i18n.t('f.registered.object'), {
        autoHideDelay: 4000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: 'success',
        solid: true
      })
    }
  }

}
</script>

<style scoped>
.bg-grey-custom {
  background: #F0F0F0 0% 0% no-repeat padding-box;
  border-radius: 4px;
  opacity: 1;
}

.text-grey {
  color: var(--main-grey);
}

.spinner {
  animation: spinning-spinner 1.2s linear infinite;
}

@keyframes spinning-spinner {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/videoRobustagno/VideoCreateEdit.vue